import Vue from "vue";
import {PersonnelService} from "@/common/api.service";
import {SAVE_EDITED_PERSON_ASSET_BY_PERSON_ID, FETCH_PERSON_ASSET_LIST_BY_ID, DELETE_PERSON_ASSET_BY_PERSON_ID, CANCEL_PERSON_ASSET_EDIT_STATE, DELETE_PERSON_ASSET, FETCH_PERSON_ASSET_LIST, SAVE_EDITED_PERSON_ASSET, SAVE_NEW_PERSON_ASSET, SAVE_NEW_PERSON_ASSET_BY_PERSON_ID, UPDATE_PERSON_ASSET} from "./actions.js";
import {
    FETCH_PERSON_ASSETS_END,
    LOAD_PERSON_ASSET_TO_EDIT,
    RESET_DEFAULT_NEW_PERSON_ASSET,
    RESET_DEFAULT_PERSON_ASSET_TO_EDIT,
    RESET_DEFAULT_ASSET_TO_EDIT,
    TOGGLE_EDIT_PERSON_ASSET_DIALOG,
    TOGGLE_NEW_PERSON_ASSET_DIALOG,
    TOGGLE_PERSON_ASSET_EDIT_STATE,
    UPDATE_ADD_PERSON_ASSET_FIELD,
    UPDATE_EDIT_PERSON_ASSET_FIELD,
    UPDATE_NEW_PERSON_ASSET,
    FILTER_ASSETS,
    FILTER_PERSON_ASSET_LIST_BY_ASSET_TYPE,
    FILTER_PERSON_ASSET_LIST_BY_PERSON_ID,
    FILTER_PERSON_ASSET_LIST_BY_ASSET_STATUS
} from "./mutations.js";

import {SET_TOASTER_MESSAGE} from "../this_app/mutations";

const functions = {

    // sort on key values
    sortString(key,desc) {
        return function(a,b){
            // console.log(a);
            // console.log(b);
            return desc ? ~~(a[key] < b[key]) : ~~(a[key] > b[key]);
        }
    },

    compareStringsDesc(a, b) {
        // Use toUpperCase() to ignore character casing
        const stringA = moment(a.string);
        const stringB = moment(b.string);

        let comparison = 0;
        if (stringA.isAfter(stringB)) {
            comparison = -1;
        } else if (stringA.isBefore(stringB)) {
            comparison = -0;
        }
        return comparison;
    },
    compareStringsAsc(a, b) {
        // Use toUpperCase() to ignore character casing
        const stringA = moment(a.string);
        const stringB = moment(b.string);

        let comparison = -1;
        if (stringA.isAfter(stringB)) {
            comparison = -0;
        } else if (stringA.isBefore(stringB)) {
            comparison = -1;
        }
        return comparison;
    }
};

const state = {
    personAssetList: [],
    editPersonAsset: {
        description: '',
        assetTypeId: undefined,
        acquisitionDate: false,
        warrantyExpiryDate: undefined,
        cost: undefined,
        currencyId: undefined,
        ecsReferenceCode: undefined,
        comments: undefined,
        assetStatusId: undefined,
    },
    addPersonAsset: {
        description: '',
        assetTypeId: undefined,
        acquisitionDate: undefined,
        warrantyExpiryDate: undefined,
        cost: undefined,
        currencyId: undefined,
        ecsReferenceCode: undefined,
        comments: undefined,
        assetStatusId: undefined,
    },
    editPersonAssetDialog: false,
    addPersonAssetDialog: false,
    assetTableSearch: "",
    filterPersonAssetListByAssetType: "",
    filterPersonAssetListByAssetStatus: "",
    filterPersonAssetListByPersonId: "",
};

const getDefaultState = () => {
    return {
        defaultPersonAsset: {
            description: '',
            assetTypeId: undefined,
            acquisitionDate: undefined,
            warrantyExpiryDate: undefined,
            cost: undefined,
            currencyId: undefined,
            ecsReferenceCode: undefined,
            comments: undefined,
            assetStatusId: undefined,
        },
    }
};

const getters = {
    assetTableSearch(state){
        return state.assetTableSearch;
    },
    addPersonAssetDialog(state) {
        return state.addPersonAssetDialog;
    },
    editPersonAssetDialog(state) {
        return state.editPersonAssetDialog;
    },
    personAssetList(state) {
        return state.personAssetList;
    },

    personAssetListForTable(state, getters) {
        let filteredPersonAssetList = state.personAssetList;
        if (state.filterPersonAssetListByAssetType != '') {
            filteredPersonAssetList = filteredPersonAssetList.filter(function (itm) {
                if (itm.assetTypeId) {
                    return state.filterPersonAssetListByAssetType.includes(itm.assetTypeId);
                }
            });
        }

        if (state.filterPersonAssetListByPersonId != '') {
            filteredPersonAssetList = filteredPersonAssetList.filter(function (itm) {
                if (itm.personId) {
                    return state.filterPersonAssetListByPersonId.includes(itm.personId);
                }
            });
        }

        if (state.filterPersonAssetListByAssetStatus != '') {
            filteredPersonAssetList = filteredPersonAssetList.filter(function (itm) {
                return state.filterPersonAssetListByAssetStatus.includes(itm.assetStatusId);
            });
        }

        filteredPersonAssetList.forEach(function (item, key) {

            let personName = getters.getPersonNameById(item.personId);

            if (personName == undefined) {
                personName = "Not Assigned"
            }

            filteredPersonAssetList[key]['personName'] = personName;
        });

        filteredPersonAssetList.forEach(function (item, key) {
            let assetTypeName = getters.getAssetTypeNameById(item.assetTypeId);

            if (assetTypeName == undefined) {
                assetTypeName = "Not Defined"
            }

            filteredPersonAssetList[key]['assetTypeName'] = assetTypeName;
        });

        filteredPersonAssetList.forEach(function (item, key) {
            let assetStatusName = getters.getAssetStatusNameById(item.assetStatusId);

            if (assetStatusName == undefined) {
                assetStatusName = "Not Defined"
            }

            filteredPersonAssetList[key]['assetStatusName'] = assetStatusName;
        });


        return filteredPersonAssetList;
    },

    personAssetListSorted(state, sortOrder) {
        // `this` points to the vm instance
        let frozenAssetList = Object.freeze(state.personAssetList);
        let jsonedAssetList = JSON.parse(JSON.stringify(frozenAssetList));

        return jsonedAssetList.sort(functions.sortString('name', sortOrder));
        // if (sortOrder == 'asc') {
        //     return jsonedAssetList.sort(functions.compareDatesAsc);
        // } else {
        //     return jsonedAssetList.sort(functions.compareDatesDesc);
        // }
    },
    editStateAsset(state) {
        return state.editStateAsset;
    },
};

const actions = {
    [FETCH_PERSON_ASSET_LIST]({commit}) {
        return PersonnelService.getAllPersonAssets()
            .then(({data}) => {
                commit(FETCH_PERSON_ASSETS_END, data);
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to fetch asset list'});
            });
    },
    [FETCH_PERSON_ASSET_LIST_BY_ID]({commit}, personId) {
        return PersonnelService.getPersonAssetsById(personId)
            .then(({data}) => {
                commit(FETCH_PERSON_ASSETS_END, data);
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to fetch asset list'});
            });
    },
    [CANCEL_PERSON_ASSET_EDIT_STATE]({commit, dispatch}, params) {
        dispatch(FETCH_PERSON_ASSET_LIST, params.personId);
        commit(TOGGLE_PERSON_ASSET_EDIT_STATE, params.field);
    },
    [SAVE_NEW_PERSON_ASSET_BY_PERSON_ID]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const newPersonAsset = state.addPersonAsset;
        const personId = state.addPersonAsset.personId;
        return PersonnelService.savePersonAsset(newPersonAsset)
            .then(() => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record saved'});
                dispatch(FETCH_PERSON_ASSET_LIST_BY_ID, personId);
                // return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Asset failed to save'});
            });
    },
    [SAVE_NEW_PERSON_ASSET]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const newPersonAsset = state.addPersonAsset;
        return PersonnelService.savePersonAsset(newPersonAsset)
            .then(() => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record saved'});
                dispatch(FETCH_PERSON_ASSET_LIST);
                // return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Asset failed to save'});
            });
    },

    [SAVE_EDITED_PERSON_ASSET]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const editedPersonAsset = state.editPersonAsset;
        return PersonnelService.updatePersonAsset(editedPersonAsset)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record updated'});
                commit(RESET_DEFAULT_PERSON_ASSET_TO_EDIT);
                dispatch(FETCH_PERSON_ASSET_LIST, editedPersonAsset.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Asset failed to update'});
            });
    },
    [SAVE_EDITED_PERSON_ASSET_BY_PERSON_ID]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const editedPersonAsset = state.editPersonAsset;
        return PersonnelService.updatePersonAsset(editedPersonAsset)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record updated'});
                commit(RESET_DEFAULT_PERSON_ASSET_TO_EDIT);
                dispatch(FETCH_PERSON_ASSET_LIST_BY_ID, editedPersonAsset.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Asset failed to update'});
            });
    },
    [UPDATE_PERSON_ASSET]({commit, dispatch}, params) {
        return PersonnelService.updatePersonAsset(state.editPersonAsset)
            .then(({data}) => {
                commit(RESET_DEFAULT_ASSET_TO_EDIT);
                dispatch(FETCH_PERSON_ASSET_LIST, params.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Asset failed to update'});
            });
    },

    [DELETE_PERSON_ASSET]({commit, dispatch}, params) {
        return PersonnelService.deletePersonAsset(params.assetId)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record deleted'});
                dispatch(FETCH_PERSON_ASSET_LIST, params.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Asset failed to delete'});
            });
    },

    [DELETE_PERSON_ASSET_BY_PERSON_ID]({commit, dispatch}, params) {
        return PersonnelService.deletePersonAsset(params.assetId)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record deleted'});
                dispatch(FETCH_PERSON_ASSET_LIST_BY_ID, params.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Asset failed to delete'});
            });
    },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [FILTER_ASSETS](state, value) {
        state.assetTableSearch = value;
    },
    [FILTER_PERSON_ASSET_LIST_BY_ASSET_TYPE](state, value) {
        state.filterPersonAssetListByAssetType = value;
    },
    [FILTER_PERSON_ASSET_LIST_BY_ASSET_STATUS](state, value) {
        state.filterPersonAssetListByAssetStatus = value;
    },
    [FILTER_PERSON_ASSET_LIST_BY_PERSON_ID](state, value) {
        state.filterPersonAssetListByPersonId = value;
    },
    [TOGGLE_NEW_PERSON_ASSET_DIALOG](state) {
        state.addPersonAssetDialog = !state.addPersonAssetDialog;
    },
    [TOGGLE_EDIT_PERSON_ASSET_DIALOG](state) {
        state.editPersonAssetDialog = !state.editPersonAssetDialog;
    },

    [RESET_DEFAULT_NEW_PERSON_ASSET](state, personId) {
        state.addPersonAsset = getDefaultState().defaultPersonAsset;
        state.addPersonAsset.personId = personId;
    },
    [RESET_DEFAULT_PERSON_ASSET_TO_EDIT](state) {
        state.editPersonAsset = getDefaultState().defaultPersonAsset;
    },

    [LOAD_PERSON_ASSET_TO_EDIT](state, assetId) {
        // noinspection UnnecessaryLocalVariableJS
        const itemToEdit = state.personAssetList.find((list) =>
            list.assetId == assetId);
        state.editPersonAsset = itemToEdit;
    },
    [TOGGLE_PERSON_ASSET_EDIT_STATE](state, field) {
        state.editStateAsset[field] = !state.editStateAsset[field];
    },
    [UPDATE_EDIT_PERSON_ASSET_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.editPersonAsset[data.objectKey][0][data.key] = data.value;
        } else {
            state.editPersonAsset[data.key] = data.value;
        }
    },
    [UPDATE_ADD_PERSON_ASSET_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.addPersonAsset[data.objectKey][0][data.key] = data.value;
        } else {
            state.addPersonAsset[data.key] = data.value;
        }
    },
    [FETCH_PERSON_ASSETS_END](state, data) {
        state.personAssetList = data;
        //state.articlesCount = articlesCount;
        state.isLoading = false;
    },
    [UPDATE_NEW_PERSON_ASSET](state, data) {
        if (data.objectKey !== undefined) {
            state.editPersonAsset[data.objectKey][0][data.key] = data.value;
        } else {
            state.editPersonAsset[data.key] = data.value;
        }
    },
};


export default {
    state,
    getters,
    actions,
    mutations,
};
